import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,

        orders: []
    },

    mutations: {
        set(state, orders) {
            state.orders = orders;
        },

        setLoading(state, loading) {
            state.loading = loading;
        }
    },

    actions: {
        confirm({commit}, order) {
            return HTTP.post('/order/do-order', order)
                .then(resp => console.log('order result', resp.data))
                // .catch(err => console.log('order err', err.response)) // so we could deal with the error on the checkout cart submit confirmation 
                ;
        },

        load({commit}) {
            commit('setLoading', true);

            return HTTP.get('/order/')
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err.response, {root: true}));
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/order.js